import * as React from "react";
import { cleanedErrors } from "@/utils/Functions";
import {
  Errors as LastOccupiedDateErrors,
  errorsOf as lastOccupiedDateErrorsOf,
  LastOccupiedDateField,
  propertyFieldsFromRecord as lastOccupiedDatePropertyFieldsFromRecord,
  Record as LastOccupiedDateRecord,
} from "./LastOccupiedDateField";
import {
  Errors as OwnershipStatusErrors,
  errorsOf as ownershipStatusErrorsOf,
  infoAvailable as ownershipStatusInfoAvailable,
  OwnershipStatusField,
  propertyFieldsFromRecord as ownershipStatusPropertyFieldsFromRecord,
  Record as OwnershipStatusRecord,
} from "./OwnershipStatusField";
import { Property } from "@/types/property";

export type Record = LastOccupiedDateRecord & OwnershipStatusRecord;

export type Errors = LastOccupiedDateErrors & OwnershipStatusErrors;

export const errorsOf: (r?: Record) => Errors = (r) => {
  return cleanedErrors({
    ...ownershipStatusErrorsOf(r),
    ...lastOccupiedDateErrorsOf(r),
  });
};

export const vacantPropertyInfoAvailable = (property: Property) => {
  return ownershipStatusInfoAvailable(property);
};

export const vacantPropertyPropertyFieldsFromRecord = (record?: Record): Partial<Property> => {
  if (!record) return {};

  return {
    ...lastOccupiedDatePropertyFieldsFromRecord(record),
    ...ownershipStatusPropertyFieldsFromRecord(record),
  };
};

export const VacantPropertyFields: React.FC<{
  record: Record;
  update: any;
  errors: any;
  serviceProviderId?: string;
}> = ({ record, update, errors, serviceProviderId }) => {
  return (
    <>
      <LastOccupiedDateField
        record={record}
        update={update}
        errors={errors}
        serviceProviderId={serviceProviderId}
      />
      <OwnershipStatusField
        record={record}
        update={update}
        errors={errors}
        serviceProviderId={serviceProviderId}
      />
    </>
  );
};
